require('./bootstrap')
require('./bootstrap-dropdown-submenu')
window.Vue = require('vue')

import LiveSearchComponent from './components/LiveSearchComponent'
import CartWidgetComponent from './components/CartWidgetComponent'
import PurchaseFormComponent from './components/PurchaseFormComponent'
import FancyBoxComponent from './components/FancyBoxComponent'
import ProductAmountComponent from './components/ProductAmountComponent'

const app = new Vue({
  el: '#app',
  components: {
    'LiveSearch': LiveSearchComponent,
    'CartWidget': CartWidgetComponent,
    'PurchaseForm': PurchaseFormComponent,
    'FancyBox': FancyBoxComponent,
    'ProductAmount': ProductAmountComponent,
  },
})